import React, { memo } from "react"
import styled, { css } from "styled-components"
import moment from "moment"

import { Paragraph, Link, PlainLink } from "components/text"
import Icon, { IconName } from "components/icon"
import Grid, { Col } from "components/grid"
import { Flex } from "components/box"

import { baseRoutes } from "routes"

const linkCSS = css`
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`

const SocialLink = styled.a.attrs({
  target: "_blank"
})``

const FooterLink = styled(Link).attrs({
  mr: [3, 3, 6, 6]
})`
  ${linkCSS}
`

const BrandLink = styled(PlainLink).attrs({ target: "_blank", mr: [3, 3, 6, 6], fontSize: "0.75rem" })`
  ${linkCSS};
  font-family: ${props => props.theme.fonts.paragraph};
`

type Links = {
  href: string
  name: IconName
}

const brandLinks = [
  { href: "https://thirtymadison.com/", name: "Thirty Madison" },
  { href: "https://www.keeps.com/", name: "Keeps" },
  { href: "https://www.withcove.com/", name: "Cove" },
  { href: "https://evens.com/", name: "Evens" }
]

const links: Links[] = [
  { href: "https://www.instagram.com/withcove/", name: "instagram" },
  { href: "https://www.facebook.com/withcove", name: "facebook" },
  { href: "https://www.twitter.com/withcove/", name: "twitter" },
  { href: "https://www.linkedin.com/company/withcove/", name: "linkedin" }
]

const AdditionalLinks = () => (
  <Grid rowProps={{ alignItems: "unset" }}>
    <Col cols={[4, 4, 12, 12]} mt={[5, null, 0]} mb={[0, null, 5]} order={[2, null, 1]}>
      {brandLinks.map(({ href, name }) => (
        <BrandLink key={href + name} href={href}>
          {name}
        </BrandLink>
      ))}
    </Col>
    <Col cols={[4, 4, 6, 7]} mt={[5, null, 0]} order={[3, null, 2]}>
      <Flex flexWrap="wrap">
        <Paragraph fontSize={0} whiteSpace="nowrap" mr={[3, 3, 6, 6]}>
          &copy; {moment().format("YYYY")} Cove
        </Paragraph>
        <FooterLink to={baseRoutes.legalsProvacyPolicy()}>
          <Paragraph fontSize={0}>Privacy Policy</Paragraph>
        </FooterLink>
        <FooterLink to={baseRoutes.legalsTermsOfUse()}>
          <Paragraph fontSize={0}>Terms &amp; Conditions</Paragraph>
        </FooterLink>
        <FooterLink to={baseRoutes.legalsConsent()}>
          <Paragraph fontSize={0}>Informed Consent</Paragraph>
        </FooterLink>
      </Flex>
    </Col>
    <Col cols={[2, 2, 3, 3]} mt={[5, null, 0]} order={[1, null, 3]}>
      <Flex justifyContent="space-between">
        {links.map(({ href, name }) => (
          <SocialLink key={href + name} href={href}>
            <Icon name={name} />
          </SocialLink>
        ))}
      </Flex>
    </Col>
  </Grid>
)

export default memo(AdditionalLinks)
